/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Start_LinkInputs */

const en_wc_start_link = /** @type {(inputs: Wc_Start_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the beginner tutorials`)
};

/**
* | output |
* | --- |
* | "Read the beginner tutorials" |
*
* @param {Wc_Start_LinkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_start_link = /** @type {((inputs?: Wc_Start_LinkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Start_LinkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_start_link(inputs)
});
export { wc_start_link as "wc.start.link" }